import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
const state = {
    // 用户信息
    userData: {
        address: "",
        collector: 0,
        idNumber: "",
        identity: null,
        name: "",
        phone: null,
        roleId: null,
        roleIdList: null,
        sex: null,
        userId: "",
        userName: "",
        yhm:"",
    },
    // 最近登录时间
    loginTime: "",
    // 当前用户菜单
    menuList: [],
    // 当前用户被授权的按钮列表
    btnAuthorityList: [],
    changePasswordDialog: false,
    noticeList: [],
    authorData: {},
    lesson1: [],
    lesson2: []
};
const getters = {
    getNoticeList(state) {
        return state.noticeList;
    },
    getUserData(state) {
        return state.userData;
    },
    getLoginTime(state) {
        return state.loginTime;
    },
    getMenuList(state) {
        return state.menuList;
    },
    getChangePasswordDialog(state) {
        return state.changePasswordDialog;
    },
    getBtnAuthorityList(state) {
        return state.btnAuthorityList
    },
    getAuthorData(state) {
        return state.authorData
    },
    getLesson(state) {
        let newArr = [...state.lesson1, ...state.lesson2];
        let map = new Map();
        for (let item of newArr) {
            if (!map.has(item.value)) {
                map.set(item.value, item);
            }
        }
        return [...map.values()];
    }
};
const mutations = {
    updateNoticeList(state, val) {
        state.noticeList = val
    },
    updateUserData(state, obj) {
        state.userData = obj
    },
    updateLoginTime(state, val) {
        state.loginTime = val
    },
    updateMenuList(state, val) {
        state.menuList = val
    },
    updateChangePasswordDialog(state, val) {
        state.changePasswordDialog = val
    },
    // 更新获取当前用户被授权的按钮列表
    updateBtnAuthorityList(state, arr) {
        state.btnAuthorityList = arr
    },
    updataAuthorData(state, obj) {
        state.authorData = obj
    },
    updataLesson1(state, arr) {
        state.lesson1 = arr
    },
    updataLesson2(state, arr) {
        state.lesson2 = arr
    },
    updataLesson3(state, arr) {
        state.lesson1 = state.lesson1.concat(arr)
    },
    updataLesson4(state, arr) {
        state.lesson2 = state.lesson2.concat(arr)
    }
};
const actions = {};
const modules = {};
export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    // 添加插件在F5刷新前将数据存储入sessionStorage中，刷新后将数据恢复
    plugins: [
        createPersistedState({
            storage: window.sessionStorage
        })
    ],
    modules: {}
});


// WEBPACK FOOTER //
// ./src/store/index.js